import * as React from "react";
import { PureComponent } from "react";
import GlobalState from "../../context/GlobalState";
import GlobalView from "../GlobalView";
import "./../../styles/config.scss";

class App extends PureComponent {
  render() {
    return (
      <GlobalState {...this.props}>
        <GlobalView />
      </GlobalState>
    );
  }
}

export default App;
